import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

const OperatingDaysStatistics = React.lazy(() => import("./OperatingDaysStatistics"));
const ActiveUsersByLibrary = React.lazy(() => import('./users/ActiveUsersByLibrary'));
const ActiveUsersByCategory = React.lazy(() => import('./users/ActiveUsersByCategory'));
const ActiveUsersByOrgUnit = React.lazy(() => import('./users/ActiveUsersByOrgUnit'));
const CirculationOfMaterialsByInst = React.lazy(() => import('./circulationOfMaterials/CirculationOfMaterialsByInst'));
const CirculationOfMaterialsByLibrary = React.lazy(() => import('./circulationOfMaterials/CirculationOfMaterialsByLibrary'));
const TurnstileData = React.lazy(() => import('./TurnstileData'));
const GeneralCollection = React.lazy(() => import('./acervos/GeneralCollection'));
const MecQ83Collection = React.lazy(() => import('./acervos/MecQ83Collection'));
const MecQ83ABCollection = React.lazy(() => import( './acervos/MecQ83ABCollection'));

const StatisticsDetails = () => {
    const location = useLocation()
    const { route } = useParams();


    return route === 'estat_bib_funcionamento' && <OperatingDaysStatistics /> ||
    route === 'estat_bib_catracas' && <TurnstileData /> ||
    route === 'estat_usu_inst_bib' && <ActiveUsersByLibrary /> ||
    route === 'estat_usu_inst_categ_usu' && <ActiveUsersByCategory /> ||
    route === 'estat_usu_inst_uo' && <ActiveUsersByOrgUnit /> ||
    route === 'estat_circ_mat_inst' && <CirculationOfMaterialsByInst /> ||
    route === 'estat_circ_mat_bib' && <CirculationOfMaterialsByLibrary /> ||
    route === 'estat_acervo_geral' && <GeneralCollection /> ||
    route === 'estat_mec_q83' && <MecQ83Collection /> ||
    route === 'estat_mec_q83_a' && <MecQ83ABCollection type='A' /> ||
    route === 'estat_mec_q83_b' && <MecQ83ABCollection type='B' /> ||
        <div style={{height: '100vh'}} className='container d-flex justify-content-center align-items-center'>
            <h4 className='text-danger'>Página não encontrada!</h4>
        </div>

}

export default StatisticsDetails;
